import { Box, Divider, Grid } from '@mui/material'
import React from 'react'
import { COLORS } from 'styles/colors'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import {
	IRationArray,
	IRationTableComponents,
} from '../../models/IRationSystem'
import { CardStandart } from '../../ui/CardStandart'
import { TypographyHeader } from '../../ui/typography/TypographyHeader'
import { TypographyPrimary } from '../../ui/typography/TypographyPrimary'
import { TypographyPrimary14Bold } from '../../ui/typography/TypographyPrimary14Bold'
import CustomTooltip from '../shared/CustomTooltip'
import { roundingNumber } from '../shared/processes'

export default function RationCompositionComp({
	rationInfo,
	rationCompById,
}: {
	rationInfo: IRationArray
	rationCompById: IRationTableComponents[]
}) {
	const fullCVWeightPerHeadArray = []
	const fullWeightPerHeadArray = []

	const waterWeight =
		(100 * +rationInfo.finallyDryMatterKg -
			+rationInfo.finallyCV * +rationInfo.finallyWeightMatterKg) /
		+rationInfo.finallyCV

	return (
		<CardStandart>
			<Box sx={{ padding: '24px' }}>
				<TypographyHeader>Состав</TypographyHeader>
				<Box
					sx={{
						marginTop: '16px',
						display: 'flex',
						flexDirection: 'row',
						gap: '8px',
					}}
				>
					<TypographySecondary14>Влажность рациона:</TypographySecondary14>
					<TypographyPrimary>
						{roundingNumber(rationInfo.food_humidity, 2)}{' '}
						<span style={{ color: COLORS.secondaryFont }}>%</span>
					</TypographyPrimary>
				</Box>
				<Box
					sx={{
						width: '100%',
						height: 'auto',
						backgroundColor: '#fff',
						borderRadius: '12px',
						marginTop: '16px',
					}}
				>
					<Grid
						container
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
						}}
					>
						<Grid item xs={8} sm={4} md={4} lg={4} xl={6}>
							<TypographySecondary>Компоненты</TypographySecondary>
						</Grid>
						<Grid
							item
							xs={1}
							sm={2}
							md={1}
							lg={0.8}
							xl={0.6}
							sx={{ textAlign: 'center' }}
						>
							<TypographySecondary>СВ, %</TypographySecondary>
						</Grid>
						<Grid
							item
							xs={1}
							sm={3}
							md={2}
							lg={1.8}
							xl={1.3}
							sx={{ textAlign: 'center' }}
						>
							<TypographySecondary>СВ, кг/голову</TypographySecondary>
						</Grid>
						<Grid
							item
							xs={1}
							sm={3}
							md={2}
							lg={1.8}
							xl={1.3}
							sx={{ textAlign: 'center' }}
						>
							<TypographySecondary>Вес, кг/голову</TypographySecondary>
						</Grid>
						<Grid item xs={1} sm={1} md={1} lg={1} xl={1}></Grid>
					</Grid>
					<Divider sx={{ marginTop: '8px' }} />
					<Grid
						container
						sx={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
						}}
					>
						<>
							<Grid
								item
								xs={8}
								sm={4}
								md={4}
								lg={4}
								xl={6}
								sx={{ marginTop: '20px' }}
							>
								<TypographyPrimary>Вода</TypographyPrimary>
							</Grid>
							<Grid
								item
								xs={1}
								sm={2}
								md={1}
								lg={0.8}
								xl={0.6}
								sx={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<TypographySecondary14>-</TypographySecondary14>
							</Grid>
							<Grid
								item
								xs={1}
								sm={3}
								md={2}
								lg={1.8}
								xl={1.3}
								sx={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<TypographySecondary14>-</TypographySecondary14>
							</Grid>
							<Grid
								item
								xs={1}
								sm={3}
								md={2}
								lg={1.8}
								xl={1.3}
								sx={{
									display: 'flex',
									flexDirection: 'row',
									alignItems: 'center',
									justifyContent: 'center',
								}}
							>
								<TypographyPrimary>
									{roundingNumber(waterWeight, 2)}
								</TypographyPrimary>
								<TypographySecondary14 sx={{ marginLeft: '8px' }}>
									кг/гол
								</TypographySecondary14>
							</Grid>
							<Grid item xs={1} sm={1} md={1} lg={1} xl={1}></Grid>
						</>
						{rationInfo.components.map(info => {
							const component = rationCompById.find(
								comp => comp.id === info.component_id,
							)

							if (!component) {
								return null
							}
							const weightPerHead =
								(+info.dry_per_head * 100) / component.dry_matter_percent
							fullCVWeightPerHeadArray.push(info.dry_per_head)
							fullWeightPerHeadArray.push(weightPerHead)
							return (
								<React.Fragment key={info.component_id}>
									<Grid
										item
										xs={8}
										sm={4}
										md={4}
										lg={4}
										xl={6}
										sx={{ marginTop: '20px' }}
									>
										<TypographyPrimary>{component.title}</TypographyPrimary>
									</Grid>
									<Grid
										item
										xs={1}
										sm={2}
										md={1}
										lg={0.8}
										xl={0.6}
										sx={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<TypographyPrimary>
											{roundingNumber(component.dry_matter_percent, 2)}
										</TypographyPrimary>
										<TypographySecondary14 sx={{ marginLeft: '8px' }}>
											%
										</TypographySecondary14>
									</Grid>
									<Grid
										item
										xs={1}
										sm={3}
										md={2}
										lg={1.8}
										xl={1.3}
										sx={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<TypographyPrimary>
											{roundingNumber(info.dry_per_head, 2)}
										</TypographyPrimary>
										<TypographySecondary14 sx={{ marginLeft: '8px' }}>
											кг/гол
										</TypographySecondary14>
									</Grid>
									<Grid
										item
										xs={1}
										sm={3}
										md={2}
										lg={1.8}
										xl={1.3}
										sx={{
											display: 'flex',
											flexDirection: 'row',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<TypographyPrimary>
											{roundingNumber(info.head_weight, 2)}
										</TypographyPrimary>
										<TypographySecondary14 sx={{ marginLeft: '8px' }}>
											кг/гол
										</TypographySecondary14>
									</Grid>
									<Grid item xs={1} sm={1} md={1} lg={1} xl={1}></Grid>
								</React.Fragment>
							)
						})}
					</Grid>

					<Divider sx={{ marginTop: '8px' }} />
					<Grid
						container
						sx={{
							marginTop: '16px',
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
						}}
					>
						<Grid
							item
							xs={8}
							sm={4}
							md={4}
							lg={4}
							xl={6}
							sx={{ textAlign: 'right', paddingRight: '30px' }}
						>
							<TypographyPrimary14Bold>
								Итого в рационе:
							</TypographyPrimary14Bold>
						</Grid>
						<Grid
							item
							xs={1}
							sm={2}
							md={1}
							lg={1}
							xl={0.8}
							sx={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<TypographyPrimary14Bold>
								{rationInfo.finallyCV
									? roundingNumber(rationInfo.finallyCV, 2)
									: '-'}
							</TypographyPrimary14Bold>
							<TypographySecondary14
								sx={{ marginLeft: '8px', marginRight: '4px' }}
							>
								%
							</TypographySecondary14>
							<CustomTooltip
								width={'16px'}
								height={'16px'}
								info={true}
								placement={'top'}
								title={
									'СВ,% рациона расчитывается исходя из долей компонентов в рационе.'
								}
							/>
						</Grid>
						<Grid
							item
							xs={1}
							sm={3}
							md={2}
							lg={1.5}
							xl={1.1}
							sx={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<TypographyPrimary14Bold>
								{roundingNumber(rationInfo.finallyDryMatterKg, 2)}
							</TypographyPrimary14Bold>
							<TypographySecondary14 sx={{ marginLeft: '8px' }}>
								кг/гол
							</TypographySecondary14>
						</Grid>
						<Grid
							item
							xs={1}
							sm={3}
							md={2}
							lg={2}
							xl={1.3}
							sx={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'center',
							}}
						>
							<TypographyPrimary14Bold>
								{roundingNumber(
									+rationInfo.finallyWeightMatterKg + waterWeight,
									2,
								)}
							</TypographyPrimary14Bold>
							<TypographySecondary14 sx={{ marginLeft: '8px' }}>
								кг/гол
							</TypographySecondary14>
						</Grid>
						<Grid item xs={1} sm={1} md={1} lg={1} xl={1}></Grid>
					</Grid>
				</Box>
			</Box>
		</CardStandart>
	)
}
